
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/better-direct-mail",
      function () {
        return require("private-next-pages/better-direct-mail.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/better-direct-mail"])
      });
    }
  